
/**
 * Reducer
 */

const initialState = {
    tes: 'a'
};

export default function app(state = initialState, action) {
    switch (action.type) {
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/app.js